import { FC } from 'react'
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const PageIsLoading: FC<{}> = () => {
    return <Typography align='center' variant={'h2'}><CircularProgress /></Typography>
}

export default PageIsLoading